(() => {
  if (document.documentElement.dataset.cmsScrollRevealInitialized === 'true') return;
  document.documentElement.dataset.cmsScrollRevealInitialized = 'true';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const init = () => {
    const elements = Array.from(document.querySelectorAll('[data-cms-scroll-reveal="true"]'));

    if (!elements.length) return;

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      elements.forEach((element) => {
        element.classList.add('cms-scroll-reveal', 'is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -10% 0px'
      }
    );

    elements.forEach((element) => {
      element.classList.add('cms-scroll-reveal');
      observer.observe(element);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
